// The client's credit report (ITC / TransUnion) on the upload step: whether
// it may be sent. The same rules as the API's (utils/affordability/
// clientBureau.js), with the messages from the shared guide
// (GET /api/credit-report-guide). Pure: tested in creditReportView.test.js.

export const CREDIT_REPORT_ACCEPT = 'application/pdf,image/jpeg,image/png';
const ALLOWED = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];

// Used only until the guide has loaded (or when it cannot be reached).
export const FALLBACK_MESSAGES = {
  required: "Your credit report is required. The Microlending Act (section 24(4)) and NAMFISA Standard ML.S.4 require a credit check before a loan can be granted. Tap 'How do I get this?' for help.",
  date_required: 'Enter the date on your credit report.',
  too_old: 'Your credit report is older than 30 days. Please request a new one from TransUnion.',
  future_date: 'The credit report date cannot be in the future.',
  file_type: 'The credit report must be a PDF, JPG or PNG file.',
};

const ymd = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

/**
 * The message to show, or null when the report may be sent.
 * required: a client applying (staff capturing may leave it out).
 */
export const creditReportError = ({ file, reportDate, required = true, today = new Date(), messages = FALLBACK_MESSAGES, maxAgeDays = 30 }) => {
  const m = { ...FALLBACK_MESSAGES, ...(messages || {}) };
  if (!file) return required ? m.required : null;
  if (file.type && !ALLOWED.includes(String(file.type).toLowerCase())) return m.file_type;
  const date = String(reportDate || '').slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return m.date_required;
  const todayText = ymd(today);
  if (date > todayText) return m.future_date;
  const age = Math.round((new Date(`${todayText}T00:00:00`) - new Date(`${date}T00:00:00`)) / 86400000);
  if (age > Number(maxAgeDays)) return m.too_old;
  return null;
};

/** The guide's email as a link (the subject filled in). */
export const guideMailto = (guide) => guide?.mailto
  || `mailto:${guide?.email || 'SA_Namibia-FreeReport@transunion.com'}?subject=${encodeURIComponent(guide?.email_subject || 'Free credit report request')}`;
